<template>
  <!-- <transition name="modal"> -->
  <div class="game-scaleable-wrapper" id="game-scaleable-wrapper">
    <div
      class="game-very-specific-design"
      id="game-very-specific-design"
      :style="
        'width:' +
        mainContenWidth +
        'px;height:' +
        mainContenHeight +
        'px ;transform:translate(-50%, -50%) scale(' +
        scale +
        ') ;'
      "
    >
      <button type="close" title="Zamknij ćwiczenie" name="close" @click="closeGame()" class="close-button">
        <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            fill="rgb(230, 230, 230)"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <div class="game-wrapper">
        <tr-game-body>
          <div class="game-body" slot="body">
            <component
              :is="componentEngine"
              :start-game-config="gameConfig"
              :assets="assets"
              :game-id="gameData.id"
              :key="componentKey"
            ></component>
          </div>
        </tr-game-body>
        <tr-ui-title
          v-for="(title, index) in gameData.item.title"
          :key="gameData.id + '_' + index"
          class="freePosition"
          :title-text="title.text"
          :audio="title.audio"
          :pos="title.pos"
          :multi-stage="multiStage"
        ></tr-ui-title>
        <!-- <tr-game-status :gameStatus="actualGameStatus"></tr-game-status> -->
        <!-- <tr-game-status :gameStatus="actualGameStatus"
                      v-show="(!gameData.item.hideControlPanel && !gameConfig.withoutCheck)"></tr-game-status> -->
        <tr-game-status
          :game-status="actualGameStatus"
          v-show="!gameData.item.hideControlPanel && !gameConfig.withoutCheck && gameData.item.engine != 'croppImg'"
        ></tr-game-status>
        <tr-game-control-panel
          @changeGameStatus="changeGameStatus()"
          v-if="!gameData.item.hideControlPanel"
        ></tr-game-control-panel>
        <tr-game-points-panel v-if="visiblePointsUI"></tr-game-points-panel>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import TrUiTitle from './UI/TrUiTitle/TrUiTitle';
import TrGameBody from './TrGameBody/TrGameBody';
import TrGameControlPanel from './UI/TrGameControlPanel/TrGameControlPanel';
import TrGameStatus from './UI/TrGameStatus/TrGameStatus';
import TrGamePointsPanel from './UI/TrPoints/TrGamePointsPanel';
/** gameEngins components */
import TrTestMulti from './GameEngines/TestMulti/TrTestMulti';
import TrTestMultiCheckboxImpr from './GameEngines/TestMulti/TrTestMultiCheckboxImpr';
import TrMultiCheckbox from './GameEngines/TestMulti/TrMultiCheckbox';
import TrMultiCheckboxImpr from './GameEngines/TestMulti/TrMultiCheckboxImpr';
import TrTestBoolean from './GameEngines/TestBoolean/TrTestBoolean';
import TrTextBlockWithInput from './GameEngines/TextBlockWithInput/TrTextBlockWithInput';
import TrTextBlockWithInputImpr from './GameEngines/TextBlockWithInput/TrTextBlockWithInputImpr';
import TrInputOnBackground from './GameEngines/InputOnBackground/TrInputOnBackground';
import TrInputOnBackgroundWithoutCheck from './GameEngines/InputOnBackground/TrInputOnBackgroundWithoutCheck';
import TrTestSelectGame from './GameEngines/SelectGame/TrTestSelectGame';
import TrSelectGameWithText from './GameEngines/SelectGame/TrSelectGameWithText';
import TrSelectImage from './GameEngines/SelectImage/TrSelectImage';
import TrConcept from './TrConcept/TrConcept';
import TrSelectGame from './GameEngines/SelectGame/TrSelectGame';
import TrTextAreaOnBackground from './GameEngines/TextAreaOnBackground/TrTextAreaOnBackground';
import TrSelectGameWithTextImpr from './GameEngines/SelectGame/TrSelectGameWithTextImpr';
import TrStepByStep from './GameEngines/StepByStep/TrStepByStep';
import TrStepByStepComics from './GameEngines/StepByStep/TrStepByStepComics';

//MB
import TrCroppImg from './GameEngines/MbCroppImg/MbCroppImg';
import TrPuzzle from './GameEngines/MbPuzzle/MbPuzzle';
import TrBalloonsGame from './GameEngines/MbBalloonsGame/MbBalloonsGame';
import TrImageSelect from './GameEngines/MbImageSelect/MbImageSelect';
import TrMemory from './GameEngines/MbMemory/MbMemory';
import TrTestWithPoints from './GameEngines/MbTestWithPoints/MbTestWithPoints';
import TrSteps from './GameEngines/MbSteps/MbSteps';
// MZ
import MzColoring from './GameEngines/MzColoring/MzColoring';
import MzLabyrinth from './GameEngines/MzLabyrinth/MzLabyrinth';
import MzKaraoke from './GameEngines/MzKaraoke/MzKaraoke';
// VUE
import MpChooseAnswer from './GameEngines/MpChooseAnswer/MpChooseAnswer';
import MpChooseAnswer16 from './GameEngines/MpChooseAnswer/MpChooseAnswer16';
import MpChooseAnswer04 from './GameEngines/MpChooseAnswer/MpChooseAnswer04';
import MpCrossword from './GameEngines/MpCrossword/MpCrossword';
import MpCrossword2 from './GameEngines/MpCrossword/MpCrossword2';
import MpFindWords from './GameEngines/MpFindWords/MpFindWords';
import MpFindWords2 from './GameEngines/MpFindWords/MpFindWords02';
import MpGalleryFade from './GameEngines/MpGallery/MpGalleryFade';
import MpGallerySvgAnime from './GameEngines/MpGallery/MpGallerySvgAnime';
// import MpGallerySvgSnap from './GameEngines/MpGallery/MpGallerySvgSnap';
import MpMendelejew from './GameEngines/MpMendelejew/MpMendelejew';
import MpMillionaires from './GameEngines/MpMillionaires/MpMillionaires';
import MpModelShow from './GameEngines/MpModel3d/MpModel3d';
import MpTextSelect from './GameEngines/MpTextSelect/MpTextSelect';

// CREATE JS
import MpCreateJS from './GameEngines/MpCreateJS/MpCreateJS';

export default {
  name: 'tr-game',
  props: {
    multibookType: {
      type: String,
      default: `${process.env.MULTIBOOK_TYPE}`,
    },
  },
  components: {
    TrUiTitle,
    TrGameBody,
    TrGameControlPanel,
    TrGameStatus,
    TrGamePointsPanel,
    TrTestMulti,
    TrTestMultiCheckboxImpr,
    TrTestBoolean,
    TrTextBlockWithInput,
    TrInputOnBackground,
    TrInputOnBackgroundWithoutCheck,
    TrTestSelectGame,
    TrSelectGameWithText,
    TrSelectImage,
    TrConcept,
    MpFindWords,
    MpFindWords2,
    MpModelShow,
    MpTextSelect,
    MpChooseAnswer,
    MpChooseAnswer16,
    MpChooseAnswer04,
    MpCrossword,
    MpCrossword2,
    MpMillionaires,
    MpMendelejew,
    MpGalleryFade,
    MpGallerySvgAnime,
    // MpGallerySvgSnap,
    MpCreateJS,
    TrSelectGame,
    TrMultiCheckbox,
    TrMultiCheckboxImpr,
    TrTextBlockWithInputImpr,
    TrTextAreaOnBackground,
    TrSelectGameWithTextImpr,
    TrStepByStep,
    TrTestWithPoints,
    TrStepByStepComics,
    TrCroppImg,
    TrBalloonsGame,
    TrImageSelect,
    TrMemory,
    TrSteps,
    TrPuzzle,
    MzColoring,
    MzLabyrinth,
    MzKaraoke,
  },
  mounted() {
    let $innerWindow = $('.game-scaleable-wrapper');
    let $el = $('.game-very-specific-design');
    let elHeight = $el.outerHeight();
    let elWidth = $el.outerWidth();

    function doResize(event, ui) {
      // console.log( 'Resize' );
      let scale, origin;
      scale = Math.min($innerWindow.width() / elWidth, $innerWindow.height() / elHeight);
      // this.$store
      $el.css({
        transform: 'translate(-50%, -50%) ' + 'scale(' + scale + ')',
        '-webkit-transform-origin': 'center center',
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
        // '-webkit-filter': 'blur(.0px)',
        // '-webkit-filter': scale,
        // transform: translateZ( 0 ),
      });
    }
    let resize = doResize.bind(this);
    let starterData = {
      size: {
        width: $innerWindow.width(),
        height: $innerWindow.height(),
      },
    };
    resize(null, starterData);

    if (this.gameConfig.withoutCheck) {
      this.$store.dispatch('disablingCheckAction');
    }
  },
  destroyed() {
    if (this.$store.getters.realMultibookType) {
      console.log('MULTIBOOKTYPECHANGE!!!!');
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.realMultibookType);
      this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      console.log(from);
    });
  },
  data() {
    return {
      prevRoute: null,
    };
  },
  methods: {
    closeGame() {
      this.$store.dispatch('closeGame');
      // console.log('this', this);
      if (this.prevRoute && this.prevRoute.name == 'songs-view') {
        console.log();
        this.$router.push('/page/songs');
      } else {
        if (this.$route.name === 'game') {
          let actualPage = `${parseInt(this.$store.getters[`${this.correctModuleName}/getActualPage`].id)}`;
          console.log('actualPage', actualPage);
          this.$router.push(`/page/${actualPage * 2 - 1}`);
        }
      }
    },
    resetGameAction() {
      this.containerEnd = _.cloneDeep(config.containerEnd);
      this.containerStart = _.cloneDeep(config.containerStart);
      this.correctList = _.cloneDeep(config.correctList);
    },
  },
  computed: {
    componentKey() {
      return this.$store.getters.componentKey;
    },
    correctModuleName() {
      let name = this.$store.getters.multibookType;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    },
    componentEngine() {
      let author = this.gameData.item.author || 'TR';
      author = _.chain(author).toLower().upperFirst().value();
      return this.gameData.item.engine.replace(/^\w{0,1}/, function (a) {
        return `${author}${a.toUpperCase()}`;
      });
    },
    mainContenWidth() {
      return 1920 || this.$store.getters.mainContenWidth;
    },
    mainContenHeight() {
      return 1080 || this.$store.getters.mainContenHeight;
    },
    scale() {
      return this.$store.getters.scale || 1;
    },
    multiStage() {
      return this.$store.getters.multiStageTest;
    },
    gameData() {
      // if (this.multiStage) {
      //   return _.cloneDeep(_.first(this.$store.getters.gameData.items));
      // }
      return this.$store.getters.gameData;
    },
    /**
     * get game confioguration data-key
     * @method gameConfig
     * @return {Object}   configuration objec
     */
    gameConfig() {
      return _.cloneDeep(this.gameData.item.gameConfig);
    },
    assets() {
      return _.cloneDeep(this.gameData.item.assets);
    },
    actualGameStatus() {
      return this.$store.getters.actualGameStatus;
    },
    visiblePointsUI() {
      return this.$store.getters.multistageVisiblePointsUI;
    },
  },
  // watch: {
  //   gameData: {
  //     handler: _.debounce(function (gameData) {
  //       this.$store.commit('CHANGE_GAME_CONTENT', gameData);
  //     }, 500),
  //     deep: true
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
.game-container {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
}
.game-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  .game-body {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
  }
  .freePosition {
    display: flex;
    position: absolute;
  }
}
.game-scaleable-wrapper {
  resize: both;
  position: relative;
  background: $offScaleColor;
  height: calc(var(--vh, 1vh) * 100);
  z-index: 8;
  overflow-y: hidden;
  overflow-x: hidden;
  .game-very-specific-design {
    width: 1920px;
    height: 1080px;
    text-align: center;
    background: $gamebackgroundColor;
    position: relative;
    left: 50%;
    top: 50%;
    transform-origin: center center 0;
  }
}

.close-button {
  pointer-events: auto;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 1;
  z-index: 1003;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: $backgroundControlPanelColor;
  margin-right: 12px;
  margin-top: 22px;
  border-radius: 50%;
  // top: -47px !important;
  // right: -50px !important;
  display: flex;
  transform: scale(1);
  padding: 0;
  svg {
    path:first-child {
      fill: $bacgroundColor;
      // transform: scale(0.8);
      transition: all 0.4s ease;
    }
  }
  &:hover {
    svg {
      path:first-child {
        fill: $closeActiveColor;
        transition: all 0.4s ease;
      }
    }
    // background-color: $borderColor;
    // transform: scale(1.1);
    transition: all 0.4s ease;
    // opacity: 1;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.test-button {
  display: flex;
  width: 20%;
  height: 5%;
  position: absolute;
  top: 92%;
  left: 58%;
  font-size: 30px;
  .test-button-text {
    width: 100%;
    // border-radius: 10px;
  }
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-very-specific-design {
  top: 0 !important;
  left: 0 !important;
  // width: 1366px !important;
  // height: 768px !important;
  transform: translate(0%, 0%) scale(1) !important;
  transform-origin: center center 0;
  -webkit-font-smoothing: subpixel-antialiased;
  backface-visibility: hidden;
  .close-button {
    right: 26% !important;
    transform: translate(-50%, -50%) scale(0.7) !important;
  }
}
// .hack-game-cotrol-panel,
// .hack-game-status,
// .hack-game-title-wrapper {
//     transform: translate(-50%, -50%) scale(0.7)!important;
//     left: 32.5% !important;
//     top: 2% !important;
// }
//
// .hack-game-status {
//     left: 58.5% !important;
//     top: 66.8% !important;
// }
// .hack-game-cotrol-panel {
//     left: 67.5% !important;
//     top: 68.5% !important;
// }
</style>
